"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconAerFanRGB = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.845 11.822C23.845 5.348 18.578 0 12.023 0 5.54 0 .2 5.27.2 11.822c0 6.505 5.29 11.823 11.823 11.823 6.497 0 11.822-5.284 11.822-11.822zm-12.591 3.265a3.35 3.35 0 01-2.503-4.002 3.35 3.35 0 014.043-2.526 3.351 3.351 0 012.485 4.065 3.351 3.351 0 01-4.025 2.463zm9.663 2.192L16.7 12.584a4.735 4.735 0 00-.257-2.474h5.875a10.39 10.39 0 01-1.401 7.17zm1.073-8.555h-6.38a4.727 4.727 0 00-1.353-1.08l4.354-3.91a10.47 10.47 0 013.38 4.99zm-4.538-5.812L12.745 7.14a4.728 4.728 0 00-2.48.28V1.537a10.38 10.38 0 017.187 1.375zM8.879 1.875v6.4a4.72 4.72 0 00-1.053 1.344L3.913 5.26a10.506 10.506 0 014.966-3.386zM3.094 6.423l4.239 4.72a4.737 4.737 0 00.287 2.438H1.737c-.415-2.4.013-4.95 1.357-7.158zm-1.018 8.543h6.4c.38.43.823.775 1.315 1.038l-4.354 3.909a10.507 10.507 0 01-3.36-4.947zm4.52 5.769l4.708-4.229a4.74 4.74 0 002.431-.263v5.873a10.367 10.367 0 01-7.14-1.381zm8.525 1.048V15.41a4.733 4.733 0 001.066-1.324l3.905 4.348a10.513 10.513 0 01-4.971 3.35z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.278 2.863a1.016 1.016 0 100-2.032 1.016 1.016 0 000 2.032zm19.535 0a1.016 1.016 0 100-2.032 1.016 1.016 0 000 2.032zM2.278 22.583a1.016 1.016 0 100-2.032 1.016 1.016 0 000 2.032zm19.535 0a1.016 1.016 0 100-2.032 1.016 1.016 0 000 2.032zM12.005 9.228a2.65 2.65 0 110 5.3 2.65 2.65 0 010-5.3zm0 1.5a1.15 1.15 0 100 2.3 1.15 1.15 0 000-2.3z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconAerFanRGB, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;